import _extends from "@babel/runtime/helpers/esm/extends";
/**
 * To set digital data for Adobe DTM
 */
export function setDigitalData(digitalData) {
  var win = window;
  if (Object.keys(digitalData).length === 0) resetDigitalData();
  win.digitalData = _extends({}, win.digitalData, digitalData);
}
function resetDigitalData() {
  var win = window;
  var _ref = win.digitalData || {},
    TestsearchData = _ref.TestsearchData,
    eventData = _ref.eventData,
    pageData = _ref.pageData,
    pageData1 = _ref.pageData1,
    siteData = _ref.siteData,
    siteData1 = _ref.siteData1,
    userData = _ref.userData,
    userData1 = _ref.userData1;
  win.digitalData = {
    TestsearchData: TestsearchData,
    eventData: eventData,
    pageData: pageData,
    pageData1: pageData1,
    siteData: siteData,
    siteData1: siteData1,
    userData: userData,
    userData1: userData1
  };
}